import { getOrganizationById } from "@/api";
import { AdminPageContent } from "@/components/admin";
import { useBreadcrumb } from "@/contexts/shared/breadcrumb";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import { useMountEffect } from "@react-hookz/web";
import { useSuspenseQuery } from "@tanstack/react-query";
import { useParams } from "react-router";
import { OrganizationInformation } from "./components/OrganizationInformation";
import { OrganizationLogo } from "./components/OrganizationLogo";
import { OrganizationSettings } from "./components/settings/OrganizationSettings";
import { ClauseChecklistsTable } from "./components/tables/ClauseChecklistsTable";
import { RecentCompareInChartsTable } from "./components/tables/RecentCompareInChartsTable";
import { RecentScopesTable } from "./components/tables/RecentScopesTable";
import { UsersTable } from "./components/tables/UsersTable";

const AdminOrganizationDetails = () => {
    const { orgId } = useParams();
    const { setBreadcrumbs } = useBreadcrumb();

    useDocumentTitle("Organization");

    const { data: organization } = useSuspenseQuery({
        queryKey: ["admin-organization-details", orgId],
        queryFn: () => getOrganizationById(Number(orgId)),
    });

    useMountEffect(() => {
        setBreadcrumbs([
            { label: "Admin", path: "home" },
            { label: "Organizations", path: "organizations" },
            { label: organization.name },
        ]);
    });

    return (
        <AdminPageContent>
            <OrganizationLogo organization={organization} />
            <OrganizationInformation organization={organization} />
            <OrganizationSettings organization={organization} />
            <UsersTable organization={organization} />
            <ClauseChecklistsTable organization={organization} />
            <RecentScopesTable organization={organization} />
            <RecentCompareInChartsTable organization={organization} />
        </AdminPageContent>
    );
};

export default AdminOrganizationDetails;
